"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const clients = [{
  id: 1,
  name: "Kérastase",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/logo_kerastase.png"
}, {
  id: 2,
  name: "Olaplex",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/logo_olaplex.png"
}, {
  id: 3,
  name: "Redken",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/logo_redken.png"
}, {
  id: 4,
  name: "Wella Professionals",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/logo_wella.png"
}, {
  id: 5,
  name: "L'Oréal Professionnel",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/logo_loreal.png"
}, {
  id: 6,
  name: "Moroccanoil",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/logo_moroccanoil.png"
}];
export default function TrustedByLeaders() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="109464" id="hoogwaardige-partners" className="bg-[#F7F7F7] py-16 md:py-24 border-y border-[#E5E7EB] overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-8 max-w-7xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="sr-only">Hoogwaardige Partners</h2>
        <p className="text-center text-xs font-medium text-[#6B7280] mb-10 uppercase tracking-[0.1em] font-sans">
          Wij werken uitsluitend met
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-10 md:gap-x-20 lg:gap-x-24">
          {clients.map((client, i) => <img key={client.id} data-index={i} src={client.src} alt={client.name} className="h-8 md:h-10 lg:h-12 w-auto object-contain grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all duration-400 ease-in-out cursor-pointer" />)}
        </div>
      </div>
    </section>;
}